export const GET_PMP_LIST = 'GET_PMP_LIST';
export const API_CALL_STATUS = 'API_CALL_STATUS';
export const POST_PMP_DATA = 'POST_PMP_DATA';
export const IS_PMP_PLANNER = 'IS_PMP_PLANNER';
export const GET_TECHNICIAN_LIST = 'GET_TECHNICIAN_LIST';
export const SELECTED_DATA_INFO = 'SELECTED_DATA_INFO';
export const GET_PMP_REPORT_DATA = 'GET_PMP_REPORT_DATA';
export const CLEAR_DATA = 'CLEAR_DATA';
export const GET_WORKREQUEST_REPORT_DATA = 'GET_WORKREQUEST_REPORT_DATA'